export default __webpack_public_path__ + "static/media/A0001.2b5159f2.png";